<template>
    <div class="flex flex-col">
        <a
            :class="preview ? 'w-24' : 'w-56'"
            :href="preview ? undefined : getUrl"
            :target="preview ? undefined : '_blank'"
            class="overflow-hidden flex flex-col text-gray-800 dark:text-white"
        >
            <!-- Thumbnail ou ícone fallback -->
            <div v-if="thumb" :class="preview ? 'h-16' : 'h-32'"
                 class="w-full bg-blue-50 dark:bg-gray-700 flex items-center justify-center overflow-hidden rounded-t-lg">
                <img
                    :src="thumb"
                    alt="thumbnail"
                    class="w-full h-full object-cover"
                >
            </div>
            <div v-else :class="preview ? 'h-16' : 'h-32'"
                 class="flex items-center gap-2 rounded-sm border border-gray-300 bg-white p-2 hover:bg-gray-50 transition-colors dark:border-gray-600 dark:bg-gray-700 dark:hover:bg-gray-700 justify-center">
                <svg
                    :class="preview ? 'w-8 h-8' : 'w-12 h-12'"
                    class="text-gray-400"
                    fill="none" stroke="currentColor" stroke-width="1.5"
                    viewBox="0 0 24 24">
                    <path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                          stroke-linecap="round"
                          stroke-linejoin="round"/>
                    <path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" stroke-linecap="round"
                          stroke-linejoin="round"/>
                </svg>
            </div>

            <!-- Info da localização -->
            <div class="px-2 py-1.5 flex flex-col gap-0.5">
                <!-- Nome do lugar -->
                <p v-if="message"
                   :class="preview ? 'text-xs' : 'text-sm'"
                   class="font-semibold leading-tight"
                >
                    {{ message }}
                </p>

                <!-- Endereço truncado -->
                <p v-if="clientUrl"
                   :class="preview ? 'text-[10px]' : 'text-xs'"
                   :title="clientUrl"
                   class="text-gray-500 dark:text-gray-400 leading-tight truncate"
                >
                    {{ clientUrl }}
                </p>
            </div>
        </a>

        <!-- Caption opcional -->
        <div v-if="caption"
             class="mt-1 text-sm dark:text-gray-200"
             v-html="caption"
        />
    </div>
</template>

<script lang="ts" setup>
import {computed, onMounted, ref} from "vue";

const props = defineProps(['json', 'preview']);

const clientUrl = ref<string>('');
const latitude = ref<number>(0);
const longitude = ref<number>(0);
const message = ref<string>('');
const thumb = ref<string>('');
const caption = ref<string>('');

onMounted(() => {
    try {
        const parsed = JSON.parse(props.json);
        clientUrl.value = parsed.clientUrl ?? '';
        latitude.value = parsed.latitude ?? parsed.lat ?? 0;
        longitude.value = parsed.longitude ?? parsed.long ?? 0;
        message.value = parsed.name ?? parsed.message ?? '';
        thumb.value = parsed.thumb ?? '';
        caption.value = parsed.caption ?? '';
    } catch (e) {
        const urlMatch = props.json.match(/https?:\/\/\S+/);
        if (urlMatch) {
            const decodedUrl = decodeURIComponent(urlMatch[0]);
            clientUrl.value = decodedUrl;

            const coordMatch = decodedUrl.match(/query=(-?\d+\.\d+),(-?\d+\.\d+)/);
            if (coordMatch) {
                latitude.value = parseFloat(coordMatch[1]);
                longitude.value = parseFloat(coordMatch[2]);
            }
        }
    }
});

const getUrl = computed(() =>
    `https://www.google.com/maps/search/?api=1&query=${latitude.value},${longitude.value}`
);
</script>